import React from "react";

import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { AutoComplete } from 'primereact/autocomplete';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';

import { RiskLevels, ConsequenceLevels, ProbabilityLevels } from './RiskLevels'

import UserContext from '../context/UserContext';

class RiskDetails extends React.Component {

	static contextType = UserContext;

	state = {
		risk: {
			riskID: 0,
			name: '',
			process: '',
			category: 1,
			owner: 0,
			description: '',
			rootCause: '',
			potentialConsequence: '',
			consequence: 1,
			probability: 1,
			consequenceAfter: 1,
			probabilityAfter: 1
		},
		processList: [],
		categoryList: [],
		roleList: [],
		processSuggestions: [],

	};

	componentDidMount() {
		
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			if (prevProps.risk !== this.props.risk)
				this.setState({ risk: this.props.risk });

			if (prevProps.processList !== this.props.processList)
				this.setState({ processList: this.props.processList });

			if (prevProps.categoryList !== this.props.categoryList)
				this.setState({ categoryList: this.props.categoryList });

			if (prevProps.roleList !== this.props.roleList)
				this.setState({ roleList: this.props.roleList });
		}
	}

	handleInput(event, field) {
		const value = event.target.value;
		if (this.props.onChange !== null) {
			this.props.onChange(field, value);
		}
	}


	searchProcess(event) {
		
		var processes = []; 

		if (event.query === '') {
			processes = this.state.processList.map(process => process);
		} else {
			processes = [event.query];
			processes = processes.concat(this.state.processList.filter(process => process.startsWith(event.query)));
		}
		this.setState({ processSuggestions: processes });
	}

	render() {
		const user = this.context.user
		if (this.props.isLoading)
			return (
				<div style={{ padding: '24px', display: 'flex', justifyContent: 'center' }}>
					<Spinner animation="border" />
					<div>Loading...</div>
				</div>
			);
		else
			return (	
				<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto', paddingLeft: '1rem', paddingRight: '1rem' }}>

					<Card style={{ maxWidth: '20rem', minWidth: '25rem', margin: '1.5rem', marginLeft: '0' }}>
						<Card.Body style={{ padding: '0px' }}>
							<div className="p-fluid md:w-20rem" style={{ padding: '2rem' }}>

								<div className="p-field">
									<label className="p-field-label">Name</label>
									<InputText value={this.state.risk.name} maxLength="50" onChange={(e) => { this.handleInput(e, 'name'); }} autoFocus className="w-full md:w-20rem" />
								</div>


								<div className="p-field">
									<label className="p-field-label">Area/Process</label>
									<AutoComplete value={this.state.risk.process} suggestions={this.state.processSuggestions} completeMethod={this.searchProcess.bind(this)} onChange={(e) => { this.handleInput(e, 'process'); }} dropdown className="w-full md:w-20rem" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Risk category</label>
									<Dropdown value={this.state.risk.category} onChange={(e) => { this.handleInput(e, 'category'); }} options={this.state.categoryList} optionValue="categoryID" optionLabel="name" placeholder=" " className="w-full md:w-20rem" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Owner</label>
									<Dropdown value={this.state.risk.owner} onChange={(e) => { this.handleInput(e, 'owner'); }} options={this.state.roleList} optionValue="roleID" optionLabel="name" placeholder=" " className="w-full md:w-20rem" />
								</div>
							
							</div>
						</Card.Body>
					</Card>
					<Card style={{ maxWidth: '34rem', minWidth: '34rem', margin: '1.5rem', marginLeft: '0' }}>
						<Card.Body style={{ padding: '0px' }}>
							<div className="p-fluid md:w-30rem" style={{ padding: '2rem' }}>

								<div className="p-field">
									<label className="p-field-label">Description</label>
									<InputTextarea value={this.state.risk.description} onChange={(e) => { this.handleInput(e, 'description'); }} rows={3} cols={30} placeholder="Short description of what this risk includes" className="w-full md:w-30rem" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Root cause</label>
									<InputTextarea value={this.state.risk.rootCause} onChange={(e) => { this.handleInput(e, 'rootCause'); }} rows={3} cols={30} placeholder={"Why is this a risk for " + user.organisation + "? What internal and external circumstances has made it a risk?"} className="w-full md:w-30rem" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Potential consequences</label>
									<InputTextarea value={this.state.risk.potentialConsequence} onChange={(e) => { this.handleInput(e, 'potentialConsequence'); }} rows={3} cols={30} placeholder={""} className="w-full md:w-30rem" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Response plans</label>
									<InputTextarea value={this.state.risk.responsePlans} onChange={(e) => { this.handleInput(e, 'responsePlans'); }} rows={3} cols={30} placeholder={"What do you do if the risk is realised? This can include Emergency Action Plans (EAP), Contingency Plans and Recovery Plans"} className="w-full md:w-30rem" />
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
				);
	}
}

export default (RiskDetails);